import { render, staticRenderFns } from "./SendRequestConfirmationDialog.vue?vue&type=template&id=d5e0dba4&"
import script from "./SendRequestConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./SendRequestConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports